export const ADD_USER = "ADD_USER";
export const SET_IN_CALL_STATUS = "SET_IN_CAL_STATUS";
export const SET_ACTIVE_LEAD = "SET_ACTIVE_LEAD";
export const SET_APPLOADING = "SET_APPLOADING";
export const SET_APPLOADING_ERROR = "SET_APPLOADING_ERROR";
export const SET_CURRENT_TASK = "SET_CURRENT_TASK";
export const SET_CALL_CONNECTED = "SET_CALL_CONNECTED";
export const SET_TASK_ATTRIBUTES = "SET_TASK_ATTRIBUTES";
export const SET_RINGING = "SET_RINGING";
export const RESET_STATE = "RESET_STATE";
export const SET_IN_ADMIN_CALL_STATUS = "SET_IN_ADMIN_CALL_STATUS";
export const UPDATE_APP_CONFIG = "UPDATE_APP_CONFIG";
export const SET_USER_ACCESS = "SET_USER_ACCESS";
